<app-page-shell
  title="Incomplete Enterprises"
  description="Enterprises with pending onboarding steps or missing workflow completion."
  badge="Onboarding"
>
  <div class="incomplete-enterprise-stats">
    <article class="incomplete-enterprise-stats__item">
      <span>Total Incomplete</span>
      <strong>{{ totalItems }}</strong>
    </article>
  </div>

  <div class="incomplete-enterprise-toolbar">
    <input
      class="form-control incomplete-enterprise-toolbar__search"
      type="search"
      placeholder="Search enterprises..."
      [(ngModel)]="searchQuery"
      (ngModelChange)="onFilterChange()"
    />
    <select class="form-control form-select" [(ngModel)]="sortOption" (ngModelChange)="onFilterChange()">
      @for (option of sortOptions; track option.value) {
        <option [value]="option.value">{{ option.label }}</option>
      }
    </select>
  </div>

  <app-data-table
    [columns]="columns"
    [data]="enterprises"
    [page]="page"
    [size]="size"
    [totalItems]="totalItems"
    [actions]="tableActions"
    [isLoading]="isInitialLoading"
    [isRefreshing]="isRefreshing"
    loadingMessage="Loading incomplete enterprises..."
    emptyMessage="No incomplete enterprises found."
    (pageChange)="onPageChange($event)"
    (actionClicked)="onActionClicked($event)"
  />
</app-page-shell>
